import React, { useContext } from 'react';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
export const DeviationViewContext = /*#__PURE__*/ React.createContext(DeviationViewMode.Normal);
DeviationViewContext.displayName = 'DeviationViewContext';
// hook for convenience...
export function useDeviationViewContext() {
    const viewMode = useContext(DeviationViewContext);
    const contextProps = {
        viewMode,
        isTheater: viewMode === DeviationViewMode.Theater,
        isFullscreen: viewMode === DeviationViewMode.Fullscreen
    };
    return contextProps;
}

//# sourceMappingURL=DeviationViewContext.js.map